export const FLUXOPAY_STATUS = {
  active: {
    label: "Ativo",
    tone: "green",
  },
  available: {
    label: "Disponível",
    tone: "green",
  },
  approved: {
    label: "Aprovado",
    tone: "green",
  },
  verified: {
    label: "Verificado",
    tone: "green",
  },
  paid: {
    label: "Pago",
    tone: "green",
  },
  completed: {
    label: "Concluído",
    tone: "green",
  },
  matched: {
    label: "Conciliado",
    tone: "green",
  },
  processing: {
    label: "Processando",
    tone: "blue",
  },
  requested: {
    label: "Solicitado",
    tone: "blue",
  },
  refund_in_progress: {
    label: "Estorno em processamento",
    tone: "blue",
  },
  pending: {
    label: "Pendente",
    tone: "amber",
  },
  pending_review: {
    label: "Em análise",
    tone: "amber",
  },
  pending_approval: {
    label: "Aguardando aprovação",
    tone: "amber",
  },
  onboarding: {
    label: "Em credenciamento",
    tone: "amber",
  },
  under_review: {
    label: "Em análise",
    tone: "amber",
  },
  future: {
    label: "A receber",
    tone: "amber",
  },
  scheduled: {
    label: "A receber",
    tone: "amber",
  },
  partially_refunded: {
    label: "Estornado parcialmente",
    tone: "amber",
  },
  refunded: {
    label: "Estornado",
    tone: "gray",
  },
  inactive: {
    label: "Inativo",
    tone: "gray",
  },
  cancelled: {
    label: "Cancelado",
    tone: "gray",
  },
  rejected: {
    label: "Recusado",
    tone: "red",
  },
  refund_denied: {
    label: "Estorno recusado",
    tone: "red",
  },
  failed: {
    label: "Falhou",
    tone: "red",
  },
  blocked: {
    label: "Bloqueado",
    tone: "red",
  },
  divergent: {
    label: "Divergente",
    tone: "red",
  },
  connection_error: {
    label: "Erro de conexão",
    tone: "red",
  },
};

export const fluxopayStatus = value =>
  FLUXOPAY_STATUS[value] || {
    label: value || "Não informado",
    tone: "gray",
  };

export const fluxopayStatusLabel = value =>
  fluxopayStatus(value).label;